export function login(user, token) {
    user.permissions = user.userPermissions;
    localStorage.setItem('token', token);
    let userString = JSON.stringify(user);
    localStorage.setItem('user', userString);
    localStorage.setItem('lastUser', userString);

    return {
        user,
        token,
        type: 'LOGIN'
    };
}

var defaultLoggedOutMessage = "You have been logged out";

export function logout(loggedOutMessage = defaultLoggedOutMessage) {
    return function (dispatch, getState) {
        delete localStorage.token;
        delete localStorage.user;

        dispatch({
            type: 'LOGOUT',
            loggedOutMessage
        });
    };


}



// WEBPACK FOOTER //
// ./app/auth/AuthActions.js